import {
  DrawerBody,
  DrawerContent,
  DrawerRoot,
  DrawerTrigger,
} from "toolkit/chakra/drawer";

import { IconButton } from "toolkit/chakra/icon-button";
import IconSvg from "ui/shared/IconSvg";
import Image from "next/image";
import { Link } from "toolkit/chakra/link";
import NavigationMobile from "ui/snippets/navigation/mobile/NavigationMobile";
import React from "react";
import TestnetBadge from "ui/snippets/navigation/TestnetBadge";
import { useColorModeValue } from "toolkit/chakra/color-mode";
import { useDisclosure } from "toolkit/hooks/useDisclosure";

// import NetworkLogo from "ui/snippets/networkMenu/NetworkLogo";

interface Props {
  isMarketplaceAppPage?: boolean;
}

const Burger = ({ isMarketplaceAppPage }: Props) => {
  const { open, onOpen, onClose, onOpenChange } = useDisclosure();
  const logoSrc = useColorModeValue(
    "/assets/logo-light.png",
    "/assets/logo-dark.png",
  );

  return (
    <DrawerRoot
      open={open}
      onOpenChange={onOpenChange}
      placement="start"
      lazyMount={false}
    >
      <DrawerTrigger>
        <IconButton onClick={onOpen} p={2} aria-label="Menu button">
          <IconSvg
            name="burger"
            boxSize={6}
            display="block"
            color={{ _light: "gray.600", _dark: "white" }}
          />
        </IconButton>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerBody
          display="flex"
          flexDirection="column"
          overflowX="hidden"
          overflowY="auto"
        >
          <TestnetBadge alignSelf="flex-start" />
          {/* <NetworkLogo/> */}
          <Link
            style={{
              display: "flex",
              alignItems: "center",
            }}
            href="/"
            noIcon
          >
            <Image
              src={logoSrc}
              width={210}
              height={42}
              alt="DotOneScan logo"
              className="doto-logo-navigation"
            />
          </Link>
          <div className="w-full">
            <NavigationMobile
              onNavLinkClick={onClose}
              isMarketplaceAppPage={isMarketplaceAppPage}
            />
            {/* <button
              onClick={() => {
                web3AccountWithDomain?.address &&
                !web3AccountWithDomain.isLoading
                  ? router.push("/asset")
                  : toaster.warning({
                      title: "Warning",
                      description: "You should first connect your wallet.",
                    });
              }}
              className="cursor-pointer w-full text-sm font-medium mt-2 border-2 px-1 h-10 rounded-md border-[#F5BC27]"
            >
              Asset Management
            </button> */}
          </div>
        </DrawerBody>
      </DrawerContent>
    </DrawerRoot>
  );
};

export default Burger;
